var map = {
	"./aparatos_electronicos.png": "39b4",
	"./equipos_informaticos.png": "7db5",
	"./grandres_electrodomesticos.png": "48f4",
	"./herramientas_electricas.png": "8c42",
	"./pequenos_electrodomesticos.png": "cdc7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c2ac";